import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthProvider';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import ErrorBoundary from './components/ErrorBoundary';
import { AnimeNavBar } from './components/AnimeNavBar';
import { RouteLoader } from './components/RouteLoader';
import Preloader from './components/Preloader';
import Footer from './components/Footer';
import Landing from './pages/Landing';
import Login from './pages/Login';
import AuthCallback from './contexts/AuthCallback';
import UserDashboard from './pages/UserDashboard';
import AdminDashboard from './pages/AdminDashboard';
import ProjectDetails from './pages/ProjectDetails';
import Reviews from './components/Reviews';
import Services from './components/Services';
import Team from './components/Team';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
// import Cursor from './components/CustomCursor'; // Disabled custom cursor
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollSmoother from 'gsap/ScrollSmoother';
import Archive from './components/Archive';
import FAQ from './components/FAQ';
import ClientPortal from './components/ClientPortal';
import About from './components/About/About';
import ScrollToTop from './components/ScrollToTop';
import ComingSoon from './pages/ComingSoon';
import ServiceDetails from './pages/ServiceDetails';

// Toggle this to true to show the Coming Soon page and hide the rest of the site
// Sui 
const SHOW_COMING_SOON = false;


gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

function App() {
  const [isLoading, setIsLoading] = useState(window.location.pathname === '/');

  useEffect(() => {
    // Only initialize ScrollSmoother after loading is complete and DOM is ready
    if (isLoading) return;

    ScrollSmoother.create({
      smooth: 2,
      effects: true,
      normalizeScroll: true,
    });

    ScrollTrigger.create({
      trigger: '.pin-box',
      pin: true,
      start: 'top center',
      end: '+=300',
      markers: false,
    });
  }, [isLoading]);

  return (
    <AuthProvider>
      <HelmetProvider>
        {SHOW_COMING_SOON ? (
          <ComingSoon />
        ) : isLoading ? (
          <Preloader onComplete={() => setIsLoading(false)} />
        ) : (
          <Router>
            <ScrollToTop />
            <ErrorBoundary>
              <RouteLoader />
              <AnimeNavBar />
              <div id="smooth-wrapper">
                <div id="smooth-content">
                  <Routes>
                    {/* Public routes */}
                    <Route path="/" element={<Landing />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/auth/callback" element={<AuthCallback />} />
                    <Route path="/archive" element={<Archive />} />
                    <Route path="/reviews" element={<Reviews />} />
                     <Route path="/services" element={<Services />} />
                     <Route path="/services/:slug" element={<ServiceDetails />} />
                    <Route path="/team" element={<Team />} />
                    <Route path="/testimonials" element={<Testimonials />} />
                    <Route path="/contact" element={<Contact isPage={true} />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/clientportal" element={<ClientPortal />} />
                    <Route path="/about" element={<About />} />

                    {/* Project Details Routes */}
                    <Route path="/vgfoods" element={<ProjectDetails />} />
                    <Route path="/lovematch" element={<ProjectDetails />} />
                    <Route path="/openteach" element={<ProjectDetails />} />
                    <Route path="/worldawaits" element={<ProjectDetails />} />
                    <Route path="/themunchies" element={<ProjectDetails />} />
                    <Route path="/motospace" element={<ProjectDetails />} />
                    <Route path="/koffeestation" element={<ProjectDetails />} />

                    {/* Protected routes */}
                    <Route
                      path="/dashboard"
                      element={
                        <PrivateRoute>
                          <UserDashboard />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/admin/*"
                      element={
                        <AdminRoute>
                          <AdminDashboard />
                        </AdminRoute>
                      }
                    />

                    {/* Redirect unmatched routes to home */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                  <Footer />
                </div>
              </div>
            </ErrorBoundary>
          </Router>
        )}
      </HelmetProvider>
    </AuthProvider>
  );

  //use this to upload image to cloudinary
  //   return (
  //   <div className="App">
  //     <CloudinaryUpload />
  //   </div>
  // );
}

export default App;